// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__VuMQ3","title":"styles_title__9kpx8"};